import React from 'react';
import StoreProvider from 'app/providers/StoreProvider/ui/StoreProvider';
import { GlobalLoader } from 'shared/ui';
import { MessageProvider } from 'shared/libs/hooks/useMessage/MessageProvider';
import AppLayout from './router/components/AppLayout/AppLayout';
import { persistor } from 'shared/config/store/store';
import { ConfigProvider } from 'antd';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { THEME, theme } from 'shared/const/theme';
import { Persistor } from 'redux-persist';
import { LanguageProvider } from './providers/LanguageProvider';
import 'shared/styles/index.css';
import { ModalProvider } from 'shared/libs/hooks/useResultModal/ModalProvider';

const CLDR_REGION_CODE_SIZE = 2;

export const PersistorContext = React.createContext<Persistor | null>(null);
const isValidCountryCode = (countryCode: any): boolean =>
  typeof countryCode === 'string' && countryCode.length === CLDR_REGION_CODE_SIZE;

function App(): React.JSX.Element {
  return (
    <StoreProvider>
      <PersistGate loading={null} persistor={persistor}>
        <PersistorContext.Provider value={persistor}>
          <LanguageProvider>
            <ConfigProvider wave={{ disabled: true }} theme={theme[THEME.LIGHT]}>
              <BrowserRouter>
                <MessageProvider>
                  <ModalProvider>
                    <AppLayout />
                    <GlobalLoader />
                    {/* <SoftBlockModal/> */}
                  </ModalProvider>
                </MessageProvider>
              </BrowserRouter>
            </ConfigProvider>
          </LanguageProvider>
        </PersistorContext.Provider>
      </PersistGate>
    </StoreProvider>
  );
}

export default App;
